(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function normalizeOrderNumber(value) {
    if (!value) return '';
    var cleaned = String(value).trim().toUpperCase().replace(/\s+/g, '');
    cleaned = cleaned.replace(/^#/, '');
    cleaned = cleaned.replace(/^PARAEL/i, '');
    return cleaned.replace(/[^0-9A-Z\-]/g, '');
  }

  function orderMatches(order, inputNorm) {
    if (!order || !inputNorm) return false;
    var name = normalizeOrderNumber(order.name || '');
    var number = normalizeOrderNumber(String(order.number || ''));
    if (name && (name === inputNorm || name === inputNorm.replace(/^0+/, ''))) return true;
    if (number && (number === inputNorm || number === inputNorm.replace(/^0+/, ''))) return true;
    // Accept "#1042" vs "1042" vs "Order 1042"
    if (name && name.indexOf(inputNorm) !== -1) return true;
    return false;
  }

  function parseOrders() {
    var el = document.getElementById('WithdrawalCustomerOrders');
    if (!el) return [];
    try {
      var data = JSON.parse(el.textContent || '[]');
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  ready(function () {
    var root = document.querySelector('[id^="Withdrawal-"]');
    var form = document.getElementById('WithdrawalForm');
    if (!root || !form) return;

    var step1 = form.querySelector('[data-withdrawal-step="1"]');
    var step2 = form.querySelector('[data-withdrawal-step="2"]');
    var nextBtn = form.querySelector('[data-withdrawal-next]');
    var backBtn = form.querySelector('[data-withdrawal-back]');
    var submitBtn = document.getElementById('WithdrawalForm-submit');
    var stamp = document.getElementById('WithdrawalForm-timestamp');
    var orderInput = document.getElementById('WithdrawalForm-order');
    var emailInput = document.getElementById('WithdrawalForm-email');
    var orderError = document.getElementById('WithdrawalForm-order-error');
    var bannerError = document.getElementById('WithdrawalForm-error');
    var customerOrders = parseOrders();
    var loggedIn = root.getAttribute('data-customer-logged-in') === 'true';
    var requireMatch = root.getAttribute('data-require-order-match') !== 'false';
    var validationUrl = (root.getAttribute('data-validation-url') || '').trim();

    function showStep(n) {
      if (!step1 || !step2) return;
      if (n === 1) {
        step1.hidden = false;
        step1.classList.add('is-active');
        step2.hidden = true;
        step2.classList.remove('is-active');
      } else {
        step1.hidden = true;
        step1.classList.remove('is-active');
        step2.hidden = false;
        step2.classList.add('is-active');
        if (orderInput) orderInput.focus();
      }
    }

    function setOrderError(msg) {
      if (!orderError || !orderInput) return;
      if (msg) {
        orderError.hidden = false;
        orderError.textContent = msg;
        orderInput.classList.add('is-invalid');
      } else {
        orderError.hidden = true;
        orderError.textContent = '';
        orderInput.classList.remove('is-invalid');
      }
    }

    function setBanner(msg) {
      if (!bannerError) return;
      if (msg) {
        bannerError.hidden = false;
        bannerError.textContent = msg;
      } else {
        bannerError.hidden = true;
        bannerError.textContent = '';
      }
    }

    function validateLocalOrder(orderValue, emailValue) {
      var norm = normalizeOrderNumber(orderValue);
      if (!norm) {
        return { ok: false, message: 'Introduce el número de pedido.' };
      }
      if (!/^[0-9]{1,10}$/.test(norm) && !/^[0-9A-Z\-]{2,20}$/.test(norm)) {
        return { ok: false, message: 'El número de pedido no tiene un formato válido.' };
      }

      if (loggedIn && customerOrders.length) {
        var found = customerOrders.some(function (o) {
          return orderMatches(o, norm);
        });
        if (!found) {
          return {
            ok: false,
            message:
              'Este número de pedido no coincide con ninguno de tus pedidos en Parael. Revisa el email de confirmación o el número.'
          };
        }
        // Optional: email should match order email if present
        if (emailValue) {
          var emailLower = String(emailValue).trim().toLowerCase();
          var emailOk = customerOrders.some(function (o) {
            return orderMatches(o, norm) && (!o.email || String(o.email).toLowerCase() === emailLower);
          });
          if (!emailOk) {
            return {
              ok: false,
              message: 'El email no coincide con el del pedido. Usa el mismo email de la compra.'
            };
          }
        }
        return { ok: true };
      }

      return { ok: true, needsRemote: !loggedIn };
    }

    function validateRemote(orderValue, emailValue) {
      if (!validationUrl) {
        return Promise.resolve({
          ok: false,
          message:
            'No podemos verificar este pedido sin sesión. Inicia sesión con el email de la compra o contacta con soporte si el número es correcto.'
        });
      }

      return fetch(validationUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          order: orderValue,
          email: emailValue,
          shop: window.Shopify && window.Shopify.shop ? window.Shopify.shop : ''
        })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { res: res, data: data };
          });
        })
        .then(function (payload) {
          if (!payload.res.ok || !payload.data || payload.data.valid !== true) {
            return {
              ok: false,
              message:
                (payload.data && payload.data.message) ||
                'No encontramos un pedido con ese número y email en Parael.'
            };
          }
          return { ok: true };
        })
        .catch(function () {
          return {
            ok: false,
            message: 'No hemos podido verificar el pedido ahora mismo. Inténtalo de nuevo en unos minutos.'
          };
        });
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { showStep(2); });
    if (backBtn) backBtn.addEventListener('click', function () { showStep(1); });

    if (orderInput) {
      orderInput.addEventListener('input', function () {
        setOrderError('');
        setBanner('');
      });
    }

    form.addEventListener('submit', function (event) {
      if (!requireMatch) {
        stampAndEnrich();
        return;
      }

      event.preventDefault();
      setBanner('');
      setOrderError('');

      var orderValue = orderInput ? orderInput.value : '';
      var emailValue = emailInput ? emailInput.value : '';
      var local = validateLocalOrder(orderValue, emailValue);

      if (!local.ok) {
        setOrderError(local.message);
        setBanner(local.message);
        if (orderInput) orderInput.focus();
        return;
      }

      function finishOk() {
        stampAndEnrich();
        form.submit();
      }

      if (!local.needsRemote) {
        finishOk();
        return;
      }

      // Invitados: solo se puede validar contra Shopify con URL del worker.
      // Sin URL no forzamos login (requisito UE); se envía tras chequeo de formato.
      if (!validationUrl) {
        finishOk();
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.add('is-loading');
      }

      validateRemote(orderValue, emailValue).then(function (remote) {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');
        }
        if (!remote.ok) {
          setOrderError(remote.message);
          setBanner(remote.message);
          if (orderInput) orderInput.focus();
          return;
        }
        finishOk();
      });
    });

    function stampAndEnrich() {
      var nowIso = new Date().toISOString();
      if (stamp) stamp.value = nowIso;

      var body = document.getElementById('WithdrawalForm-body');
      var order = document.getElementById('WithdrawalForm-order');
      var orderDate = document.getElementById('WithdrawalForm-order-date');
      var name = document.getElementById('WithdrawalForm-name');

      if (body && body.value.indexOf('DESISTIMIENTO_UE') === -1) {
        var meta = [
          '[DESISTIMIENTO_UE]',
          'Fecha/hora envío (ISO): ' + nowIso,
          'Nombre: ' + (name && name.value ? name.value : ''),
          'Nº pedido: ' + (order && order.value ? order.value : ''),
          'Fecha pedido: ' + (orderDate && orderDate.value ? orderDate.value : ''),
          '',
          'Declaración:'
        ].join('\n');
        body.value = meta + '\n' + body.value;
      }
    }
  });
})();
